"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _locale = require("sk-ui/lib/locale");

var _zhCN = _interopRequireDefault(require("sk-ui/lib/locale/lang/zh-CN"));

var _default = {
  empty: (0, _locale.t)('sk.form.common_term_null_valid'),
  length: _zhCN["default"].sk.form.common_term_length_valid1,
  minLength: _zhCN["default"].sk.form.common_term_minLength_valid,
  minMaxLength: _zhCN["default"].sk.form.common_term_maxlength_valid,
  number: (0, _locale.t)('sk.form.common_term_number_valid'),
  "int": (0, _locale.t)('sk.form.common_term_int_valid'),
  port: (0, _locale.t)('sk.form.common_term_port_valid'),
  lt: _zhCN["default"].sk.form.common_term_lt_valid,
  lte: _zhCN["default"].sk.form.common_term_lte_valid,
  gt: _zhCN["default"].sk.form.common_term_gt_valid,
  gte: _zhCN["default"].sk.form.common_term_gte_valid,
  maxDecimalLength: _zhCN["default"].sk.form.common_term_maxDecimalLength_valid,
  phone: (0, _locale.t)('sk.form.common_term_phone_valid'),
  email: (0, _locale.t)('sk.form.common_term_email_valid'),
  verifyCode: (0, _locale.t)('sk.form.common_term_verifyCode_valid'),
  textName: (0, _locale.t)('sk.form.common_term_cname_valid'),
  ipRangeCheck: (0, _locale.t)('sk.form.common_term_ipRangeCheck_valid'),
  mask: (0, _locale.t)('sk.form.common_term_mask_valid'),
  num: _zhCN["default"].sk.form.common_num_lt_valid,
  rightIp: (0, _locale.t)('sk.form.common_right_ip_valid'),
  availableIp: (0, _locale.t)('sk.form.common_available_ip_valid')
};
exports["default"] = _default;